import { loader } from './loader.js';
import { modifications } from './modifications.js';
function init() {
    loader();
    modifications();
}

export {
    init   
}